import { IMaintenanceModeModel } from "../../repositories/models/maintenance/maintenance-mode.model";
import { IMaintenanceMode } from "../maintenance/maintenance-mode";

export class MaintenanceModeConverter {
  public static toDomain(model: IMaintenanceModeModel): IMaintenanceMode {
    return {
      active: model.active,
      description: model.description ?? undefined,
    };
  }
}
